// extracted by mini-css-extract-plugin
export default {"purple":"style_purple__V6lhm"};